export default class CalendarHelpers {
  static getDaysInPeriod (from, zoom) {
    if (!from) {
      return 0;
    }

    let fromMonth = from.getMonth();

    if (zoom === '30') {
      return new Date(from.getFullYear(), fromMonth + 1, 0).getDate();
    }

    // If there will be longer zoom periods - we will need to calculate also year in the "to" date to avoid wrong values for February
    return new Date(from.getFullYear(), fromMonth + 1, 0).getDate() + new Date(from.getFullYear(), fromMonth + 2, 0).getDate();
  }
}
